export default __webpack_public_path__ + "static/media/eyeHidden.843760b3.svg";